export default "__VITE_ASSET__BA_m8V4R__"